import GroceryRejectedTable from 'components/GroceryRejected';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const GroceryRejected = () => {
  const permissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions,
  );
  const canView = checkPermission(permissions, {
    permissionName: 'GroceryRejected',
    permission: ['view', 'viewAll'],
  });
  return <div>{canView && <GroceryRejectedTable />}</div>;
};
